<dv-loading-button (buttonClick)="openDialog()">{{
    'DOKUMENTE_UEBERNEHMEN_BUTTON' | translate
}}</dv-loading-button>
